import { Link } from "react-router-dom";
import {
  mergeSummaryWithVisualPreset,
  resolveVisualPresetKey,
} from "../constants/ecardVisualPresets";
import { JOURNEY_CATEGORIES } from "../constants/giftJourney";
import "../styles/product.css";

function presetLabel(slug) {
  const c = JOURNEY_CATEGORIES.find((j) => j.slug === slug);
  return c?.label || "E-gift cards";
}

/**
 * One row from RTDB `gifts/{id}` (summary) — visuals merge preset + optional Firebase images.
 */
export default function HomeGiftCard({ summary, occasionSlug = "egift" }) {
  const occ = resolveVisualPresetKey(summary, occasionSlug);
  const merged = mergeSummaryWithVisualPreset(summary, occ);
  if (!merged) return null;

  const finalPrice =
    merged.Price - (merged.Price * (merged.Discount || 0)) / 100;

  return (
    <Link
      to={`/product/${encodeURIComponent(summary.id)}?occasion=${encodeURIComponent(occ)}`}
      className="product-card home-firebase-gift"
    >
      {merged.Discount > 0 && (
        <div className="discount-badge">{merged.Discount}% OFF</div>
      )}

      <div className="ecard-frame">
        <div className="image-container">
          <img src={merged.imageurl} alt="" loading="lazy" />
        </div>
      </div>

      <h3 className="product-title">{merged.Tittle || "Gift card"}</h3>

      <p className="desc">{merged.Description || "—"}</p>

      <div className="ecard-meta">
        <div className="price-box">
          {merged.Discount > 0 && (
            <span className="old-price">₹{merged.Price}</span>
          )}
          <span className="new-price">₹{Math.round(finalPrice)}</span>
        </div>
        <span className="ecard-tag">{presetLabel(occ)}</span>
      </div>

      {merged.Validity ? (
        <p className="home-gift-validity">{merged.Validity}</p>
      ) : null}
    </Link>
  );
}
